<template>
  <div class="external-box">
    <ul class="list-external row">
      <li class="col-sm-6"
          v-for="(item, i) in availableLinkList"
          :class="item.classes"
          :key="i">
        <router-link
          :to="{name: item.urlName}"
          :title="item.title">
          <span class="company-logo"/>
          <span class="title">{{item.title}}</span>
        </router-link>
      </li>
    </ul>
    <div class="external-button">
      <button
        class="btn btn-size-l"
        type="submit"
        @click="goTo({ name: 'RFQQuickRFQ' })"
      >
        <span class="icon-page"></span>
        {{L10n('quick-rfq')}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Links',
  data () {
    return {
      linkList: [
        {
          urlName: 'Companies',
          classes: 'logo-companies',
          title: this.L10n('companies'),
          permission: 'isAllowToViewCompanies'
        },
        {
          urlName: 'Stocks',
          classes: 'logo-stocks',
          title: this.L10n('stocks'),
          permission: 'isAllowToViewStocks'
        },
        {
          urlName: 'RFQPendingRFQ',
          classes: 'logo-rfq',
          title: this.L10n('rfq'),
          permission: 'isAllowToViewRFQs'
        },
        {
          urlName: 'QI',
          classes: 'logo-qi',
          title: this.L10n('qi'),
          permission: 'isAllowToViewQIs'
        },
        {
          urlName: 'Invoices',
          classes: 'logo-invoices',
          title: this.L10n('invoices'),
          permission: 'isAllowToViewFinance'
        },
        {
          urlName: 'Parts',
          classes: 'logo-parts',
          title: this.L10n('parts'),
          permission: 'isAllowToViewParts'
        }
      ]
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    availableLinkList () {
      return this.linkList.filter((link) => {
        return this.permission(this.permissions, link.permission)
      })
    }
  },
  methods: {
    goTo (location) {
      this.$router.push(location)
    }
  }
}
</script>

<style lang="stylus">
  .external-box {
    position relative
    padding 0 21rem 0 0
    .external-button {
      position absolute
      top 50%
      right 0
      transform translateY(-50%)
      .btn {
        width 18rem
        padding-left: 1rem
        padding-right: 1rem
        .icon-page {
          vertical-align middle
          line-height 0
          position relative
          top: -0.2rem
          margin-right 1.5rem

        }
      }
    }
  }

  .list-external {
    list-style none
    margin -0.8rem -0.5rem 0
    .title {
      text-transform uppercase
    }
    > li {
      padding 0.8rem 0.5rem 0
      > a {
        overflow hidden
        display block
        background #fff
        border 1px solid #eeeeef
        border-radius 3px
        min-height 100%
        padding 1rem 3rem 1rem 5rem
        text-decoration none
        font-size 1.1rem
        line-height 1.25
        color #bcbbbe
        transition all 0.3s ease
        position relative
        &::before {
          display block
          content ''
          height 1.1rem
          width 0.7rem
          background url('../../../public/img/icons.png') no-repeat -14rem 0
          background-size 50rem 50rem
          position absolute
          top 50%
          right 1.6rem
          transform translateY(-50%)
        }
        &:hover {
          background #04ace7
          border-color #04ace7
          box-shadow 0px 2px 5px 0px rgba(0, 0, 0, 0.2)
          color #fff
          .title {
            color #fff
          }
        }
        .title {
          display block
          font-size 1.6rem
          color #09729b
          font-weight bold
          transition all 0.3s ease
        }
        .subTitle {
          display block
          text-overflow ellipsis
          white-space nowrap
          overflow hidden

        }
      }
    }
    .company-logo {
      display block
      height: 2.2rem
      width: 2.2rem
      position absolute
      top 1rem
      left 1rem
      border-radius 2px
      background url('../../../public/img/left-navigation.png') no-repeat
    }
  }

  .icon-page {
    display inline-block
    height 2.1rem
    width 1.8rem
    background url('../../../public/img/icons.png') no-repeat -15rem 0
    background-size 50rem 50rem
  }
  .logo-companies{
    .company-logo{
      background-position -13.6rem -1.4rem
      height: 2rem
    }
    &:hover{
      .company-logo{
        background-position -13.6rem .4rem
      }
    }
  }
  .logo-stocks{
    .company-logo{
      background-position -15.6rem -1.5rem
      width 1.6rem
      height 2rem
    }
    &:hover{
      .company-logo{
        background-position -15.6rem .3rem
      }
    }
  }
  .logo-rfq{
    .company-logo{
      background-position -17.3rem -1.5rem
      width 1.6rem
      height 2rem
    }
    &:hover{
      .company-logo{
        background-position -17.3rem .3rem
      }
    }
  }
  .logo-qi{
    .company-logo{
      background-position -18.9rem -1.5rem
      width 1.6rem
      height 2rem
    }
    &:hover{
      .company-logo{
        background-position -18.9rem .3rem
      }
    }
  }
  .logo-invoices {
    .company-logo {
      background-position -26.7rem -1.5rem
      width 2rem
      height 2rem
    }
    &:hover {
      .company-logo {
        background-position -26.7rem .3rem
      }
    }
  }
  .logo-parts {
    .company-logo {
      background-position -15.6rem -1.5rem
      width 1.6rem
      height 2rem
    }
    &:hover {
      .company-logo {
        background-position -15.6rem .3rem
      }
    }
  }
</style>
